/* ============================================================
   OBEE EXTRACTS — Musik

   Standard ist still. Der Ton läuft erst, wenn jemand den Knopf
   in der Kopfzeile drückt; die Entscheidung wird gemerkt.

   Warum Web Audio und nicht <audio loop>:
   MP3-Dateien tragen am Anfang und Ende eine Handvoll leerer
   Bilder, die der Kodierer anlegt. Beim Schleifen hört man die
   als Stolperer — bei einem Beat sofort. Web Audio arbeitet mit
   den entschlüsselten Werten und springt taktgenau.

   Die Datei wird erst geladen, wenn der Ton eingeschaltet wird.
   Wer sie nie einschaltet, lädt keine 800 KB.
   ============================================================ */
(function () {
  'use strict';

  var btn = document.getElementById('soundBtn');
  if (!btn) return;

  var KEY  = 'obee-sound';
  var VOL  = 0.55;   // Endlautstärke
  var UP   = 1.4;    // Einblenden in Sekunden
  var DOWN = 0.5;    // Ausblenden

  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) { btn.hidden = true; return; }

  var ctx = null, gain = null, buf = null, src = null;
  var on = false, busy = false;

  /* Die Adresse kommt aus dem data-Attribut, das Liquid füllt. Dort
     hängt Shopifys eigene Version dran (?v=…). Baue ich sie im
     JavaScript zusammen, fehlt dieser Teil — und dann liefert der
     Zwischenspeicher noch tagelang die alte Datei aus. */
  function url() {
    return btn.getAttribute('data-src') ||
           (window.OBEE_ASSET ? window.OBEE_ASSET('beat.mp3') : 'assets/beat.mp3');
  }

  function paint() {
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Mute music' : 'Play music');
  }

  /* Merkt sich den laufenden Ladevorgang. Sonst startet der zweite
     Tipp einen zweiten Download, während der vom Vorladen noch
     unterwegs ist — zwei Dekodierungen für dieselbe Datei. */
  var loading = null;

  function load() {
    if (buf) return Promise.resolve(buf);
    if (loading) return loading;
    btn.classList.add('busy');
    loading = fetch(url())
      .then(function (r) { return r.arrayBuffer(); })
      .then(function (a) {
        return new Promise(function (res, rej) {
          // Ältere Safari-Fassungen kennen decodeAudioData nur mit Rückrufen
          var p = ctx.decodeAudioData(a, res, rej);
          if (p && p.then) p.then(res, rej);
        });
      })
      .then(function (b) { buf = b; loading = null; btn.classList.remove('busy'); return b; })
      .catch(function () { loading = null; btn.classList.remove('busy'); throw new Error('audio'); });
    return loading;
  }

  function play() {
    if (busy || on) return;
    busy = true;
    if (!ctx) {
      ctx = new AC();
      gain = ctx.createGain();
      gain.gain.value = 0;
      gain.connect(ctx.destination);
    }
    (ctx.state === 'suspended' ? ctx.resume() : Promise.resolve())
      .then(load)
      .then(function (b) {
        src = ctx.createBufferSource();
        src.buffer = b;
        src.loop = true;
        src.loopStart = 0;
        src.loopEnd = b.duration;   // taktgenau, ohne Lücke
        src.connect(gain);
        src.start(0);
        var t = ctx.currentTime;
        gain.gain.cancelScheduledValues(t);
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.linearRampToValueAtTime(VOL, t + UP);
        on = true; busy = false; paint();
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
      })
      .catch(function () {
        busy = false; on = false; paint();
      });
  }

  function stop(remember) {
    if (!on || busy) return;
    busy = true;
    var t = ctx.currentTime;
    gain.gain.cancelScheduledValues(t);
    gain.gain.setValueAtTime(gain.gain.value, t);
    gain.gain.linearRampToValueAtTime(0.0001, t + DOWN);
    var s = src;
    setTimeout(function () {
      try { s.stop(); s.disconnect(); } catch (e) {}
      src = null; busy = false;
    }, DOWN * 1000 + 60);
    on = false; paint();
    if (remember !== false) { try { localStorage.setItem(KEY, '0'); } catch (e) {} }
  }

  btn.addEventListener('click', function () { on ? stop() : play(); });

  /* ------------------------------------------------------------
     Start durch die zwei Klicks auf das Gerät.

     Der Beat setzt in dem Moment ein, in dem das Gerät angeht —
     der dramatischste Punkt der Seite. Erlaubt ist das, weil der
     zweite Klick eine echte Berührung ist; ohne die dürfte kein
     Browser Ton starten.

     Wer den Ton vorher bewusst ausgeschaltet hat, bleibt in Ruhe.
     Ein einmal abgelehntes Angebot wird nicht wiederholt.
     ------------------------------------------------------------ */
  window.OBEE_SOUND = {
    autostart: function () {
      var pref = null;
      try { pref = localStorage.getItem(KEY); } catch (e) {}
      if (pref === '0') return;
      play();
    },
    stop: function () { stop(false); },
    isOn: function () { return on; }
  };

  /* Im Hintergrundtab still sein — sonst dudelt die Seite in einem
     Fenster weiter, das niemand sieht. */
  document.addEventListener('visibilitychange', function () {
    if (!ctx) return;
    if (document.hidden) { if (ctx.state === 'running') ctx.suspend(); }
    else if (on && ctx.state === 'suspended') ctx.resume();
  });

  /* ------------------------------------------------------------
     Vorladen bei der ersten Berührung — meist der Knopf im Age Gate.

     Seit die Musik mit den zwei Klicks startet, braucht sie fast
     jeder Besucher. Würde die Datei erst beim Klick geladen, käme
     der Beat auf dem Mobilfunknetz Sekunden zu spät. Herunterladen
     und Entschlüsseln brauchen keine Freigabe — nur das Abspielen.

     Wer den Ton abgelehnt hat, lädt nichts.
     ------------------------------------------------------------ */
  function prime() {
    var pref = null;
    try { pref = localStorage.getItem(KEY); } catch (e) {}
    if (pref === '0' || buf) return;
    if (!ctx) {
      ctx = new AC();
      gain = ctx.createGain();
      gain.gain.value = 0;
      gain.connect(ctx.destination);
    }
    load().then(function () {
      // Wer den Ton beim letzten Besuch anhatte, bekommt ihn gleich wieder
      if (pref === '1' && !on) play();
    }).catch(function () {});
  }

  var once = function () {
    document.removeEventListener('pointerdown', once);
    document.removeEventListener('keydown', once);
    prime();
  };
  document.addEventListener('pointerdown', once, { once: true });
  document.addEventListener('keydown', once, { once: true });

  paint();
})();
